import { useSelector } from 'react-redux'

import type { PublicMetadata } from 'types/business'
import type { State } from 'types/redux'

/**
 * React hook that determines whether to use Composer instead of Artist terminology.
 *
 * Based on business configuration, returns appropriate title and value for displaying
 * either Artist or Composer across the UI. The configuration can be passed directly
 * or retrieved from Redux state.
 *
 * @param public_metadata - Optional business metadata to override Redux state
 * @returns Object with title ('Artist' or 'Composer') and corresponding value ('artist' or 'composer')
 */
export const useComposerInsteadOfArtist = (
  public_metadata?: PublicMetadata,
): {
  title: string
  value: string
} => {
  const use_composer_instead_of_artist = useSelector((state: State) => {
    if (public_metadata) return public_metadata.use_composer_instead_of_artist

    return state.user.business?.public_metadata?.use_composer_instead_of_artist
  })

  return use_composer_instead_of_artist
    ? { title: 'Composer', value: 'composer' }
    : { title: 'Artist', value: 'artist' }
}
